import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { MarqueeTicker } from './components/MarqueeTicker';
import { Services } from './components/Services';
import { GrowthPartnerBanner } from './components/GrowthPartnerBanner';
import { Portfolio } from './components/Portfolio';
import { Philosophy } from './components/Philosophy';
import { Consulta } from './components/Consulta';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
export function App() {
  return <div className="min-h-screen bg-kinetic-bg text-white font-sans selection:bg-cyan-400 selection:text-black" data-id="element-0" data-mp="31bs1ff0jszn8">
      <Navbar data-id="element-1" data-mp="2wj8g1vvmd07v" />

      <main data-id="element-2" data-mp="2wip734ny5m5z">
        <Hero data-id="element-3" data-mp="2wi5mthatqlos" />
        <StatsBar data-id="element-4" data-mp="28ufmg62gz4gf" />
        <MarqueeTicker data-id="element-5" data-mp="28tw972nrl48q" />
        <Services data-id="element-6" data-mp="28t4l0cwhy8sh" />
        <GrowthPartnerBanner data-id="element-7" data-mp="28sl5f2ubjwhm" />
        <Portfolio data-id="element-8" data-mp="23vcm2yxfpmes" />
        <Philosophy data-id="element-9" data-mp="23w4fq47h1a2f" />
        <Consulta data-id="element-10" data-mp="23ujjma5idj2g" />
      </main>

      <Footer data-id="element-11" data-mp="23t8h0dnsuhcx" />
      <FloatingWhatsApp data-id="element-12" data-mp="3ijxnsm94vshs" />
    </div>;
}